module.exports = __webpack_public_path__ + "img/close-btn.c05d812f.svg";